
define('ldsh!templates/progress-bar', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="row">\n    <div class="col-xs-12">\n        <span class="i18n pull-left progress-bar-title" data-i18n="' +
__e(title) +
'"></span>\n        <div class="pull-right">\n          <strong class="num-progress-bar">' +
__e(formatNumber(num)) +
'</strong>&nbsp;<span class="i18n" data-i18n="ACCOUNTS.STATUS.LBL_OF"></span>&nbsp;<strong class="max-progress-bar">' +
__e(formatNumber(max)) +
'</strong>\n        </div>\n    </div>\n</div>\n<div class="row">\n    <div class="col-xs-12">\n        <div class="progress">\n          <div class="progress-bar progress-bar-' +
__e((percent > 50) ? 'danger' : 'success') +
'" role="progressbar" aria-valuenow="' +
__e(percent) +
'" aria-valuemin="0" aria-valuemax="100" style="width: ' +
__e(percent) +
'%">\n                <span class="sr-only">' +
__e(percent) +
'%</span>\n            </div>\n        </div>\n    </div>\n</div>\n';

}
return __p
};});

